import { Config } from '../../config'

export const omnilabConfig: Config = {
  partner: 'omnilab',
  catalog: 'partner',
  displayName: 'OMNI Lab Solutions',
  accentColor: '#263959',
  host: 'seating.omnilabsolutions.com',
}